module.exports = __webpack_public_path__ + "img/t_store.ab031132.png";